import { taggedTemplateLiteral as _taggedTemplateLiteral, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import map from '../../node_modules/ramda/es/map.js';
import filter from '../../node_modules/ramda/es/filter.js';
import find from '../../node_modules/ramda/es/find.js';
import propEq from '../../node_modules/ramda/es/propEq.js';
import SocialNetworks from '../SocialNetworks/index.js';
import getPgaTld from '../../getPgaTld.js';

var _templateObject;
var SocialNetworksWrapped = function SocialNetworksWrapped(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(SocialNetworks, null));
};
var FooterSocialNetworks = styled(SocialNetworksWrapped)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: -5px;\n  margin-top: 15px;\n  i {\n    padding: 0 5px;\n    circle,\n    path {\n      transition: all 0.3s ease-in-out;\n    }\n    &:hover {\n      circle {\n        fill: #ab9157;\n      }\n      path {\n        fill: #00234b;\n      }\n    }\n  }\n"])));
var pgaTld = getPgaTld();
var footerOptions = {
  sections: [{
    id: 1,
    title: "PGA.org",
    options: [{
      id: 500,
      label: "My Account",
      link: "https://account.".concat(pgaTld)
    }, {
      id: 501,
      label: "Become a Member",
      link: "https://www.".concat(pgaTld, "/membership/")
    }, {
      id: 503,
      label: "Media",
      link: "https://pgamediacenter.com"
    }, {
      id: 504,
      label: "Logout",
      link: "https://account.".concat(pgaTld, "/logout")
    }, {
      id: 505,
      label: "Privacy Policy",
      link: "https://resources.".concat(pgaTld, "/privacy-policy/")
    }, {
      id: 506,
      label: "Privacy Policy",
      link: "https://www.".concat(pgaTld, "/privacy-policy/")
    }, {
      id: 507,
      label: "Terms of Service",
      link: "https://".concat(pgaTld, "/terms-of-service/")
    }, {
      id: 508,
      label: "California Notice",
      link: "https://www.".concat(pgaTld, "/california-notice")
    }, {
      id: 509,
      label: "Do Not Sell My Personal Information",
      link: "https://privacyportal.onetrust.com/webform/d026f30a-622a-40b3-b261-d78a6b839240/e468c3de-717f-44a2-8576-29799026c21a",
      external: true,
      target: "_blank"
    }]
  }, {
    id: 2,
    title: "Careers",
    options: [{
      id: 504,
      label: "Jobs in Golf",
      link: "http://jobs.".concat(pgaTld, "/")
    }, {
      id: 505,
      label: "HQ Careers",
      link: "http://careers.pgahq.com/"
    }, {
      id: 506,
      label: "Post a Job",
      link: "https://jobs.".concat(pgaTld, "/post")
    }, {
      id: 507,
      label: "Manage Jobs",
      link: "https://jobs.".concat(pgaTld, "/manage-jobs")
    }]
  }, {
    id: 3,
    title: "Resources",
    options: [{
      id: 508,
      label: "Change Forms",
      link: "https://account.".concat(pgaTld, "/profile/pga-record")
    }, {
      id: 509,
      label: "Forms Library",
      link: "https://resources.".concat(pgaTld, "/form-library/")
    }, {
      id: 510,
      label: "Path to Membership",
      link: "https://www.".concat(pgaTld, "/membership/")
    }]
  }, {
    id: 4,
    title: "Other Websites",
    options: [{
      id: 511,
      label: "PGA.com",
      link: "http://www.pga.com/",
      external: true,
      target: "_blank"
    }, {
      id: 512,
      label: "PGA Magazine",
      link: "http://pgamagazine.com/",
      external: true,
      target: "_blank"
    }, {
      id: 513,
      label: "PGA Member Store",
      link: "https://shopmyshop.com/?application=a496c986-a442-46b0-bdaf-4cfca0a61c93",
      external: true,
      target: "_blank"
    }, {
      id: 514,
      label: "Social Responsibility Report",
      link: "https://pgaimpact.org/",
      external: true,
      target: "_blank"
    }, {
      id: 515,
      label: "PGA Tournaments",
      link: "https://PGAtournaments.com",
      external: true,
      target: "_blank"
    }]
  }],
  copyrightMessage: "\xA9 ".concat(new Date().getFullYear(), " The PGA of America")
};
var socialNetworks = {
  id: 5,
  title: "Follow Us",
  options: /*#__PURE__*/React__default.createElement(FooterSocialNetworks, null)
};
var optionsOnAuth = {
  loggedIn: [{
    id: 1,
    options: [500, 504, 505, 507, 508, 509]
  }, {
    id: 2,
    options: [504, 505, 506, 507]
  }, {
    id: 3,
    options: [509, 510]
  }, {
    id: 4,
    options: [515, 512, 513, 514]
  }],
  loggedOut: [{
    id: 1,
    options: [500, 501, 503, 506, 507, 508, 509]
  }, {
    id: 2,
    options: [504, 505, 506, 507]
  }, {
    id: 3,
    options: [509]
  }, {
    id: 4,
    options: [515, 512, 513, 514]
  }]
};
var optionsFor = function optionsFor(me) {
  var optionsMap = optionsOnAuth[me && "loggedIn" || "loggedOut"];
  var sections = map(function (_ref2) {
    var sectionId = _ref2.id,
      optionsId = _ref2.options;
    var _filter$ = filter(function (_ref3) {
        var id = _ref3.id;
        return id === sectionId;
      }, footerOptions.sections)[0],
      id = _filter$.id,
      title = _filter$.title,
      options = _filter$.options;
    return {
      id: id,
      title: title,
      options: map(function (id) {
        return find(propEq("id", id), options);
      }, optionsId)
    };
  }, optionsMap);
  return [].concat(_toConsumableArray(sections), [socialNetworks]);
};

export { footerOptions, optionsFor };
